import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { GenericLinkDirective } from '@core/jss-utils';

import { MinimalHeaderComponent } from '../shared/minimal-header';
import { EcmpHeaderImageComponent } from '../shared/ecmp-header-image/ecmp-header-image.component';

@Component({
  selector: 'wl-minimal-sticky-header',
  templateUrl: './minimal-sticky-header.component.html',
  styleUrls: ['./minimal-sticky-header.component.essent.scss'],
  standalone: true,
  imports: [
    NgTemplateOutlet,
    GenericLinkDirective,
    EcmpHeaderImageComponent,
    AutomationIdDirective,
    FaIconComponent,
    DeployUrlPipe,
  ],
})
export class MinimalStickyHeaderComponent extends MinimalHeaderComponent {}
